import { Result, TrimValidationFields, backendApi } from "./backendApi";

// maybe this should go somewhere more global?
export const countries: { [id: number]: string } = {
  0: "Other",
  1: "The Netherlands",
  2: "Belgium",
  3: "United States of America",
  4: "United Kingdom",
  5: "Germany",
  6: "France",
  7: "Spain",
  8: "Portugal",
  9: "Italy",
  10: "Poland",
  11: "Czech Republic",
  12: "Sweden",
  13: "Denmark",
  14: "Norway",
  15: "Finland",
  16: "Hungary",
  17: "Croatia",
  18: "Israel",
  19: "Slovenia",
  20: "Russia",
  21: "Switzerland",
  22: "Canada",
  23: "United Arab Emirates",
  24: "Australia",
  25: "New Zealand",
  26: "South Africa",
  27: "Brazil",
  28: "Liechtenstein",
  29: "Ukraine",
  30: "Austria",
};

export interface NumberPlateModel {
  numberPlate?: string;
  trailerNumberPlate?: string;
  countryId: number;
}

class GetNumberPlatesRequest {
  recId?: number;
}

class GetNumberPlatesResponse {
  numberPlates?: NumberPlateModel[];
}

class CreateNumberPlateRequest {
  recId?: number;
  numberPlate?: NumberPlateModel;
}

class UpdateNumberPlateRequest {
  recId?: number;
  countryId?: number;
  plate?: string;
  numberPlate?: NumberPlateModel;
}

class DeleteNumberPlateRequest {
  recId?: number;
  numberPlate?: NumberPlateModel;
}

export const numberPlateAPI = {
  async getNumberPlates(recId: number): Promise<Result<NumberPlateModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetNumberPlatesResponse>(
        "GetNumberPlates",
        { recId: recId } as GetNumberPlatesRequest,
      );

    if (response.ok) {
      return { ok: true, value: response.value.numberPlates ?? [] };
    }

    return response;
  },

  async createNumberPlate(
    recId: number,
    numberPlate: NumberPlateModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateNumberPlate", {
      recId: recId,
      numberPlate: numberPlate,
    } as CreateNumberPlateRequest);

    if (response.ok) {
      return { ok: true, value: response.value.numberPlates ?? [] };
    }

    TrimValidationFields(response.problem, "NumberPlate");

    return response;
  },

  async updateNumberPlate(
    recId: number,
    countryId: number,
    plate: string,
    numberPlate: NumberPlateModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateNumberPlate", {
      recId: recId,
      countryId: countryId,
      plate: plate,
      numberPlate: numberPlate,
    } as UpdateNumberPlateRequest);

    if (response.ok) {
      return { ok: true, value: response.value.numberPlates ?? [] };
    }

    TrimValidationFields(response.problem, "NumberPlate");

    return response;
  },

  async deleteNumberPlate(
    recId: number,
    numberPlate: NumberPlateModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteNumberPlate", {
      recId: recId,
      numberPlate: numberPlate,
    } as DeleteNumberPlateRequest);

    if (response.ok) {
      return { ok: true, value: response.value.numberPlates ?? [] };
    }

    TrimValidationFields(response.problem, "NumberPlate");

    return response;
  },
};
